export * from './lib/tour-price-detail.module';
